export default __webpack_public_path__ + "static/media/apple.cea0999c.svg";